import React, { createContext, useContext, useState } from 'react';
import { SKUData } from './sku-profiling';

interface SKUContextType {
  selectedSKU: string | null;
  setSelectedSKU: (sku: string | null) => void;
  skuData: SKUData[];
  setSkuData: (data: SKUData[]) => void;
}

const SKUContext = createContext<SKUContextType | undefined>(undefined);

export const SKUProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [selectedSKU, setSelectedSKU] = useState<string | null>(null);
  const [skuData, setSkuData] = useState<SKUData[]>([]);

  return (
    <SKUContext.Provider
      value={{ selectedSKU, setSelectedSKU, skuData, setSkuData }}
    >
      {children}
    </SKUContext.Provider>
  );
};

export const useSKU = () => {
  const context = useContext(SKUContext);
  if (context === undefined) {
    throw new Error('SKU Context must be used within a SKU Provider');
  }
  return context;
};
